import { call, put } from 'redux-saga/effects';
import { fromJS } from 'immutable';
import { fetchFilters } from '../api/filters';

import {
	fetchAreaFiltersSuccess,
	fetchAreaFiltersError,
	fetchRentFiltersSuccess,
	fetchRentFiltersError,
	fetchSearchFiltersSuccess,
	fetchSearchFiltersError
} from '../actions/actionCreators';

export function* areaFiltersSaga({payload}) {
	try {
		const result = yield call( ()=> fetchFilters(payload) );
		yield put(fetchAreaFiltersSuccess(fromJS(result)));
	} catch (error) {
		yield put(fetchAreaFiltersError(error));
	}
}

export function* rentFiltersSaga({payload}) {
    try {
        const result = yield call( ()=> fetchFilters(payload) );
        yield put(fetchRentFiltersSuccess(fromJS(result)));
    } catch (error) {
        yield put(fetchRentFiltersError(error));
    }
}

export function* searchFiltersSaga({payload}) {
    try {
        const result = yield call( ()=> fetchFilters(payload) );
        yield put(fetchSearchFiltersSuccess(fromJS(result)));
    } catch (error) {
        yield put(fetchSearchFiltersError(error));
    }
}



// WEBPACK FOOTER //
// ./src/js/sagas/filtersSaga.js